import { apiRequest } from "../../services/apiService";
import {
    GET_TICKETS_REQUEST,
    GET_TICKETS_SUCCESS,
    GET_TICKETS_FAIL,
    GET_TICKET_DETAIL_REQUEST,
    GET_TICKET_DETAIL_SUCCESS,
    GET_TICKET_DETAIL_FAIL,
    CREATE_TICKET_REQUEST,
    CREATE_TICKET_SUCCESS,
    CREATE_TICKET_FAIL,
    UPDATE_TICKET_STATUS_REQUEST,
    UPDATE_TICKET_STATUS_SUCCESS,
    UPDATE_TICKET_STATUS_FAIL,
    ASSIGN_TICKET_REQUEST,
    ASSIGN_TICKET_SUCCESS,
    ASSIGN_TICKET_FAIL,
    ADD_TICKET_COMMENT_REQUEST,
    ADD_TICKET_COMMENT_SUCCESS,
    ADD_TICKET_COMMENT_FAIL,
    GET_TICKET_DASHBOARD_REQUEST,
    GET_TICKET_DASHBOARD_SUCCESS,
    GET_TICKET_DASHBOARD_FAIL,
    GET_MY_TICKETS_REQUEST,
    GET_MY_TICKETS_SUCCESS,
    GET_MY_TICKETS_FAIL,
} from "../constant";

export const getTicketList = (filters) => {
    return async (dispatch) => {
        dispatch({ type: GET_TICKETS_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/tickets/list`,
            data: filters || {},
        });
        if (response) {
            dispatch({ type: GET_TICKETS_SUCCESS, payload: response.data?.data || [] });
        } else if (error) {
            dispatch({ type: GET_TICKETS_FAIL });
        }
    };
};

export const getTicketDetail = (ticket_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_TICKET_DETAIL_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/tickets/detail`,
            data: { ticket_id },
        });
        if (response) {
            dispatch({ type: GET_TICKET_DETAIL_SUCCESS, payload: response.data?.data || null });
        } else if (error) {
            dispatch({ type: GET_TICKET_DETAIL_FAIL });
        }
    };
};

export const createTicket = (data) => {
    return async (dispatch) => {
        dispatch({ type: CREATE_TICKET_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/tickets/create`,
            data,
        });
        if (response) {
            dispatch({ type: CREATE_TICKET_SUCCESS, payload: response.data?.data });
            return { success: true, data: response.data?.data };
        } else if (error) {
            dispatch({ type: CREATE_TICKET_FAIL });
            return { success: false };
        }
    };
};

export const updateTicketStatus = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_TICKET_STATUS_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/tickets/update-status`,
            data,
            showErrorToast: false,
        });
        if (response) {
            dispatch({ type: UPDATE_TICKET_STATUS_SUCCESS });
            return { success: true };
        } else if (error) {
            dispatch({ type: UPDATE_TICKET_STATUS_FAIL });
            return { success: false };
        }
    };
};

export const assignTicket = (data) => {
    return async (dispatch) => {
        dispatch({ type: ASSIGN_TICKET_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/tickets/assign`,
            data,
            showErrorToast: false,
        });
        if (response) {
            dispatch({ type: ASSIGN_TICKET_SUCCESS });
            return { success: true };
        } else if (error) {
            dispatch({ type: ASSIGN_TICKET_FAIL });
            return { success: false };
        }
    };
};

export const addTicketComment = (data) => {
    return async (dispatch) => {
        dispatch({ type: ADD_TICKET_COMMENT_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/tickets/comment`,
            data,
            showErrorToast: false,
        });
        if (response) {
            dispatch({ type: ADD_TICKET_COMMENT_SUCCESS, payload: response.data?.data });
            return { success: true };
        } else if (error) {
            dispatch({ type: ADD_TICKET_COMMENT_FAIL });
            return { success: false };
        }
    };
};

export const getTicketDashboard = () => {
    return async (dispatch) => {
        dispatch({ type: GET_TICKET_DASHBOARD_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/tickets/dashboard`,
            data: {},
        });
        if (response) {
            dispatch({ type: GET_TICKET_DASHBOARD_SUCCESS, payload: response.data?.data || null });
        } else if (error) {
            dispatch({ type: GET_TICKET_DASHBOARD_FAIL });
        }
    };
};

export const getMyTickets = () => {
    return async (dispatch) => {
        dispatch({ type: GET_MY_TICKETS_REQUEST });
        const { response, error } = await apiRequest({
            method: "POST",
            url: `/tickets/my-tickets`,
            data: {},
        });
        if (response) {
            dispatch({ type: GET_MY_TICKETS_SUCCESS, payload: response.data?.data || [] });
        } else if (error) {
            dispatch({ type: GET_MY_TICKETS_FAIL });
        }
    };
};
